import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import AboutAudienceSection from "./-components/about/AboutAudienceSection";
import AboutCTASection from "./-components/about/AboutCTASection";
import AboutDifferentiationSection from "./-components/about/AboutDifferentiationSection";
import AboutHeroSection from "./-components/about/AboutHeroSection";
import AboutProblemSection from "./-components/about/AboutProblemSection";
import AboutSolutionSection from "./-components/about/AboutSolutionSection";
import AboutValuesSection from "./-components/about/AboutValuesSection";

export const Route = createFileRoute("/_public/about")({
	component: RouteComponent,
});

function RouteComponent() {
	const { t } = useTranslation();

	return (
		<div>
			<title>{t("about.meta.title")}</title>
			<AboutHeroSection />
			<AboutProblemSection />
			<AboutSolutionSection />
			<AboutDifferentiationSection />
			<AboutValuesSection />
			<AboutAudienceSection />
			<AboutCTASection />
		</div>
	);
}
